import { defineStore } from 'pinia';
import i18n from '@/common/i18n';
import HomeRepository from '@/repositories/homeRepository';
import NewsRepository from '@/repositories/newsRepository';
import apiResponseErrorService from '@/commonProject/service/apiResponseErrorService';
import cognitoRepository from '@/repositories/common/cognitoRepository';

export const useHomeStore = defineStore({
    id: 'home',
    state: () => ({
        Menu1: [],
        Menu2: [],
        List: [],
        EmphasisContact: false, // ヘッダー部の事務連絡の新着アイコン
        KeepNewsDetail: {
            openNewDetailModalInHomeFlag: false, // URLにニュースIDが存在し、当該お知らせが取得できた場合は、ホーム画面遷移時に当該お知らせを表示する。
            NoticeType: null,
            NoticeBulletinPk: null, // 使用しない
            NoticeHistPk: null,
        },
    }),
    getters: {},
    actions: {
        reset() {
            this.Menu1 = [];
            this.Menu2 = [];
            this.List = [];
            this.EmphasisContact = false; // ヘッダー部の事務連絡の新着アイコン
        },
        resetAll() {
            this.reset();
            // ログイン画面からニュースを初期化する。
            this.resetKeepNewsDetail();
        },
        resetKeepNewsDetail() {
            this.KeepNewsDetail = {
                openNewDetailModalInHomeFlag: false,
                NoticeType: null,
                NoticeBulletinPk: null,
                NoticeHistPk: null,
            };
        },
        /**
         * メニュー取得API
         * @param {*} API_URL
         * @param {*} requestBody
         * @returns response
         */
        async getMenuAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const homeRepository = new HomeRepository();
            try {
                const response = await homeRepository.getMenuApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.Menu1 = [];
                this.Menu2 = [];
                // ユーザー情報をstoreに格納
                this.Menu1 = response.data.CustomMenuSetting.Menu1;
                this.Menu2 = response.data.CustomMenuSetting.Menu2;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * お知らせ一覧取得API
         * @param {*} API_URL
         * @param {*} requestBody
         * @returns response
         */
        async getNewsListAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const newsRepository = new NewsRepository();
            try {
                const response = await newsRepository.getNewsListApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.List = [];
                // ユーザー情報をstoreに格納
                this.List = response.data.List;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'post', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },

        /**
         * 新着情報確認API
         * @param {*} API_URL
         * @param {*} requestBody
         * @returns response
         */
        async getArchiveCheckAction(API_URL, queryParam) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const homeRepository = new HomeRepository();
            try {
                const response = await homeRepository.getArchiveCheckApi(API_URL, queryParam, idToken);

                // 例外エラーハンドリング共通処理
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }

                return { success: true, responseBody: response.data };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'post', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },

        /**
         * ユーザー状態確認(予約)APIをコールする。
         * @param {*} API_URL
         * @param {*} queryParam
         * @returns response
         */
        async getUserStatusReserveAction(API_URL, queryParam) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const homeRepository = new HomeRepository();
            try {
                const response = await homeRepository.getUserStatusReserveActionApi(API_URL, queryParam, idToken);

                // 例外エラーハンドリング共通処理
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }

                return { success: true, responseBody: response.data };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
    },
    persist: {
        // セッションストレージに保存する。
        storage: sessionStorage,
    },
});
